import { createSlotRecipe } from './runtime.js';

const chatToolConfig = {"name":"chatTool","slots":["group","groupTrigger","groupContent","card","header","name","status","chip","body","section","sectionLabel","code"],"defaultVariants":{"status":"complete"},"variantMap":{"status":["awaiting","complete","error","running"]}}

export const chatTool = /* @__PURE__ */ createSlotRecipe(chatToolConfig)